import InvalidExchangeTokenHandler from "./InvalidExchangeTokenHandler";
import FailedTokenExchangeLimitExceededHandler from "./FailedTokenExchangeLimitExceededHandler";

import UnauthenticatedAccessAttemptHandler from "./UnauthenticatedAccessAttemptHandler";
import UnauthorizedAccessAttemptHandler from "./UnauthorizedAccessAttemptHandler";
import TokenExpiredHandler from "./TokenExpiredHandler";
import ResourceNotFoundHandler from "./ResourceNotFoundHandler";

export default [
  InvalidExchangeTokenHandler,
  FailedTokenExchangeLimitExceededHandler,
  TokenExpiredHandler,
  ResourceNotFoundHandler,

  // Fallbacks
  UnauthenticatedAccessAttemptHandler,
  UnauthorizedAccessAttemptHandler
];
